import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Components/ContentItemStore";
import { setPostStyleGuideTheme, setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import ButtonPresentationPropsDefault from "@insite/mobius/Button/presentationProps";
import { css } from "styled-components";

// const store = require.context("./Store", true);
// store.keys().forEach(key => store(key));
// if (module.hot) {
//     module.hot.accept(store.id, () => onHotWidgetReplace(require.context("./Store", true)));
// }

const services = require.context("./Services", true);
if (module.hot) {
    module.hot.accept(services.id?.toString(), () => onHotWidgetReplace(require.context("./Services", true)));
}

const widgets = require.context("./Widgets", true, /\.tsx$/);
const onHotWidgetReplace = addWidgetsFromContext(widgets);
// ensure HMR works for custom widgets
if (module.hot) {
    module.hot.accept(widgets.id?.toString(), () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
}

// Enable hot module reloading for custom widgets.
// if (module.hot) {
//     module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context('./Components/Widgets', true, /\.tsx$/)));
// }

// Load all handlers so they are included in the bundle.
// Recursively get all handler modifications
const handlers = require.context("./Handlers", true);
// Load the handler modifications.
handlers.keys().forEach(key => handlers(key));
if (module.hot) {
    module.hot.accept(handlers.id?.toString(), () => onHotWidgetReplace(require.context("./Handlers", true)));
}

// Load all the extensions to the base widgets. This includes style extensions.
const widgetExtensions = require.context("./WidgetExtensions", true);
widgetExtensions.keys().forEach(key => widgetExtensions(key));

// load all pages. Without this they won't be included in the bundle
const pages = require.context("./Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);
if (module.hot) {
    module.hot.accept(pages.id?.toString(), () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
}

setPostStyleGuideTheme({
    breakpoints: {
        keys: ["xs", "sm", "md", "lg", "xl"],
        values: [0, 576, 768, 992, 1366],
        maxWidths: [350, 350, 680, 1078, 1140],
    },
    typography: {
        fontFamilyImportUrl: "https://fonts.googleapis.com/css?family=Roboto:400,400i,500,500i,700,700i,900,900i",
        body: {
            size: "14px",
            weight: 400,
            fontFamily: "'Roboto', sans-serif",
        },
        h1: {
            size: "40px",
            weight: 500,
            fontFamily: "'Roboto', sans-serif",
            color: "#152d69",
            css: css`
                margin-bottom: 1rem;
                display: block;
                padding: 0;
            `,
        },
        headerPrimary: {
            size: "13px",
            weight: "bold",
            underline: false,
        },
        headerSecondary: {},
        headerTertiary: {},
    },
    colors: {
        primary: {
            main: "#152d69",
            contrast: "#FFFFFF",
        },
        secondary: {},
        text: {
            main: "#152d69",
            link: "#2E64B0",
        },
    },
    button: {
        primary: {
            ...ButtonPresentationPropsDefault,
            color: "primary",
            buttonType: "solid",
        },
        secondary: {},
    },
    globalStyle: {
        css: css`
            /* -------------------- GLOBAL -------------------- */
            h1,
            h2,
            h3,
            h4 {
                font-family: "Roboto", sans-serif;
                color: #152d69;
                font-weight: 500;
                padding: 0;
            }
            h1 {
                margin-top: 0;
            }
            h2 {
                font-size: 2.5em;
            }
            h3 {
                font-size: 1.5em;
                margin: 0.75em 0px 0.5em;
            }
            h4 {
                font-size: 1.5em;
            }
            ul,
            ol {
                margin-left: 2.5em;
                list-style: disc;
            }
            ul li {
                color: #333333;
                font-size: 1.1em;
                line-height: 1.5em;
                padding: 0;
                padding: 0px;
            }
            .no-margins {
                margin: 0 !important;
                padding: 0 !important;
            }
            .main-content > .column {
                margin: 25px 0 10px 0;
            }
            .hero-image {
                height: 380px;
                position: relative;
                background-size: cover;
                background-position: center center;
                margin-bottom: 0;
                position: relative;
            }
            .hero-text {
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                padding: 20px;
            }
            .hero-text h1 {
                color: #fff;
                font-size: 3.25em;
                line-height: 1.1em;
            }
            .grid {
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
            }
            .grid .column {
                -webkit-box-flex: 0;
                -ms-flex: 0 1 auto;
                flex: 0 1 auto;
                padding: 0 15px;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                width: 100%;
            }
            .grid .column p {
                color: #333333;
                font-size: 1.1em;
                line-height: 1.5em;
                margin: 0.5em 0 1em;
                padding: 0;
            }
            .grid .column.col-two-third {
                width: 66.666%;
            }
            .grid .column.col-third {
                width: 33.333%;
            }
            .grid .column.col-half {
                width: 50%;
            }

            .grid.wrapper {
                margin: 0 auto;
            }
            @media all and (max-width: 768px) {
                .grid .column {
                    width: 100% !important;
                }
            }
            @media (max-width: 768px) {
                .grid {
                    display: block;
                }

                .grid .column.col-three-fifth,
                .grid .column.col-half,
                .grid .column.col-third,
                .grid .column.col-fourth,
                .grid .column.col-fifth {
                    width: 100%;
                }
            }
            @media (min-width: 1200px) {
                .wrapper {
                    width: 1140px;
                    margin: 0 auto;
                }
            }

            @media (max-width: 1199px) {
                .wrapper {
                    padding: 0 15px;
                }
            }

            /* -------------------- SERVICES -> Automation & Equipment -------------------- */
            .video-group {
                box-sizing: border-box;
                padding-top: 10px;
                margin: 40px 0;
                border-top: 1px solid #ccc;
            }
            img {
                max-width: 100%;
            }

            /* -------------------- INDUSTRY SOLUTIONS -> Agriculture, Food Processing, Grocery  -------------------- */
            .video-container {
                position: relative;
                padding-bottom: 56.25%;
                padding-top: 25px;
                height: 0;
                margin: 20px 0 !important;
            }
            .video-container iframe {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }

            /* -------------------- HOMEPAGE -------------------- */
            .background-dark-blue {
                background: #152d69;
            }
            .widget-richcontent section p {
                font-size: 1.1em;
            }
            .widget-richcontent section .button.large {
                font-size: 25px;
                font-weight: 300;
                padding: 15px 40px;
            }
            .widget-richcontent section .button.green {
                border: 2px solid #118d45;
                background: #118d45;
                border-radius: 0px;
                -webkit-box-shadow: none;
                box-shadow: none;
                color: #fff;
            }
            .homepage-hero-mosaic,
            .homepage-accordions {
                max-width: 1800px;
            }
            .homepage-hero-mosaic {
                margin: 0 auto;
            }
            .homepage-hero-mosaic img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
            .homepage-hero-mosaic h1 {
                color: #fff;
                margin: 0 auto;
                padding: 20px 0;
                font-size: 44px;
                line-height: 48px;
                max-width: 430px;
            }
            @media all and (max-width: 630px) {
                .homepage-hero-mosaic h1 {
                    padding: 20px;
                }
            }
            @media all and (max-width: 767px) {
                .homepage-hero-mosaic .right-column {
                    display: none;
                }
                .homepage-hero-mosaic .column.col-three-fifth.left-column {
                    width: 100%;
                }
                .homepage-hero-mosaic .grid .column.col-half {
                    width: 50% !important;
                }
            }
            @media all and (min-width: 1025px) {
                .homepage-hero-mosaic h1 {
                    font-size: 54px;
                    line-height: 58px;
                    max-width: 525px;
                }
            }
            @media all and (min-width: 1181px) {
                .homepage-hero-mosaic h1 {
                    font-size: 70px;
                    line-height: 75px;
                    max-width: 655px;
                }
            }
            .homepage-hero-mosaic .grid .column {
                padding: 0 10px 10px 0;
            }

            .homepage-accordions {
                margin: 60px auto;
            }
            .homepage-accordions .column {
                position: relative;
            }
            .homepage-accordion {
                height: 440px;
                width: 100%;
                position: relative;
                cursor: pointer;
                -webkit-transition: width 0.2s ease-in-out;
                -moz-transition: width 0.2s ease-in-out;
                -o-transition: width 0.2s ease-in-out;
                transition: width 0.2s ease-in-out;
            }
            .homepage-accordion-top {
                height: 185px;
                position: relative;
                z-index: 1;
            }
            img.homepage-accordion-background {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
            .homepage-accordion-blue .homepage-accordion-top {
                background: rgba(21, 45, 105, 0.85);
            }
            .homepage-accordion-red .homepage-accordion-top {
                background: rgba(230, 30, 38, 0.85);
            }
            .homepage-accordion-button {
                position: absolute;
                top: 0;
                right: 0;
                font-size: 40px;
                color: #fff;
                font-weight: 300;
                padding: 25px;
                line-height: 25px;
                border: 1px solid #fff;
                height: 75px;
                width: 75px;
                text-align: center;
            }
            .homepage-accordion-content {
                display: none;
            }
            .homepage-accordion h3 {
                margin-top: 0;
            }
            .homepage-accordion-content p {
                color: #fff !important;
                font-size: 28px;
                line-height: 34px;
                margin: 40px 75px 0 !important;
                font-weight: 300;
            }
            .homepage-accordion.active .homepage-accordion-content {
                display: block;
            }
            .homepage-accordion.active {
                width: calc(200% + 30px);
                left: auto;
            }
            .homepage-accordion.homepage-accordion-last.active {
                position: relative;
                left: calc(-100% - 30px);
            }
            .homepage-accordion.active .homepage-accordion-top {
                height: 100%;
            }
            .homepage-accordion.active h3 {
                margin: 0 75px;
                text-align: left;
            }
            @media all and (min-width: 1181px) {
                .homepage-accordion.active {
                    left: auto;
                }
                .homepage-accordion.homepage-accordion-last.active {
                    position: relative;
                    left: calc(-100% - 30px);
                }
            }
            @media all and (max-width: 1180px) {
                .homepage-accordions .grid {
                    display: flex;
                    flex-wrap: wrap;
                }
                .homepage-accordions .grid .col-fifth {
                    width: 33%;
                    margin-bottom: 20px;
                }
                .homepage-accordion.active,
                .homepage-accordion.homepage-accordion-last.active,
                .homepage-accordions .grid .col-fifth:nth-of-type(2n) .homepage-accordion.active {
                    left: auto;
                }
                .homepage-accordions .grid .col-fifth:nth-of-type(3n) .homepage-accordion.active {
                    position: relative;
                    left: calc(-100% - 30px);
                }
            }
            @media all and (max-width: 767px) {
                .homepage-accordions .grid .col-fifth {
                    width: 50% !important;
                }
                .homepage-accordion.active,
                .homepage-accordion.homepage-accordion-last.active,
                .homepage-accordions .grid .col-fifth:nth-of-type(3n) .homepage-accordion.active {
                    left: auto;
                }
                .homepage-accordions .grid .col-fifth:nth-of-type(2n) .homepage-accordion.active {
                    position: relative;
                    left: calc(-100% - 30px);
                }
            }
            @media all and (max-width: 630px) {
                .homepage-accordion.active h3 {
                    margin: 0 40px;
                }
                .homepage-accordion-content p {
                    margin: 30px 40px 0;
                }
            }
            @media all and (max-width: 480px) {
                .homepage-accordions .grid .col-fifth {
                    width: 100% !important;
                }
                .homepage-accordion.active,
                .homepage-accordion.homepage-accordion-last.active,
                .homepage-accordions .grid .col-fifth:nth-of-type(3n) .homepage-accordion.active,
                .homepage-accordions .grid .col-fifth:nth-of-type(2n) .homepage-accordion.active {
                    left: auto;
                }
                .homepage-accordion.active {
                    width: 100% !important;
                }
                .homepage-accordion.active h3 {
                    margin: 0px 20px;
                }
                .homepage-accordion-content p {
                    margin: 20px 20px 0;
                    font-size: 20px;
                    line-height: 28px;
                }
            }

            .homepage-sustainable-solutions {
                background-image: url("userfiles/images/green-bg.jpg");
                height: 693px;
                background-repeat: no-repeat;
                background-size: cover;
                display: flex;
                align-items: center;
            }

            .homepage-sustainable-solutions h2 {
                color: #118d45;
                font-weight: 300;
            }

            .homepage-sustainable-solutions .grid {
                gap: 16px;
                align-items: center;
            }
            @media all and (max-width: 767px) {
                .homepage-sustainable-solutions .grid {
                    flex-wrap: nowrap;
                }
            }
            @media all and (max-width: 630px) {
                .homepage-sustainable-solutions {
                    height: auto;
                    padding: 40px 0;
                }
                .homepage-sustainable-solutions .grid {
                    flex-wrap: wrap;
                }
                .homepage-sustainable-solutions .grid .column.col-half {
                    width: 100% !important;
                }
                .homepage-sustainable-solutions .grid .column.col-half:first-of-type {
                    margin-bottom: 40px !important;
                }
                .homepage-sustainable-solutions .grid img {
                    max-width: 375px;
                    margin: 0 auto 20px;
                }
            }
            @media all and (max-width: 480px) {
                .homepage-sustainable-solutions .grid img {
                    max-width: 100%;
                }
            }
            .homepage-sustainable-solutions .col {
                flex: 1 1 40%;
            }

            .homepage-categories {
                padding-top: 80px;
            }

            .homepage-categories .grid,
            .susainability-page-categories .grid {
                justify-content: center;
                gap: 15px;
            }

            .homepage-categories h2,
            .homepage-intersticial h2,
            .homepage-accordions h2 {
                font-size: 40px;
                line-height: 44px;
                text-align: center;
                padding-bottom: 20px;
                font-weight: 300;
            }

            .homepage-categories h3 {
                font-size: 16px;
            }

            .homepage-accordions h3 {
                font-size: 35px;
                line-height: 41px;
                font-weight: 300;
                color: #fff;
                text-align: center;
                padding-top: 100px;
            }
            .homepage-intersticial {
                margin: 60px 0;
            }
            .homepage-intersticial h2 {
                padding-bottom: 15px;
            }
            .homepage-intersticial p {
                text-align: center;
                max-width: 850px;
                margin: 0 auto;
            }

            .homepage-categories .category-image-wrapper,
            .susainability-page-categories .category-image-wrapper {
                flex: 1;
            }
            .homepage-categories .category-image {
                height: auto;
            }
            .homepage-categories .category-image img {
                height: auto;
            }
            .homepage-categories .category-image:hover {
                transform: none;
            }
            .homepage-categories .category-image-wrapper img {
                object-fit: cover;
                width: 100%;
            }
            .susainability-page-categories img {
                object-fit: cover;
                width: 100%;
                border: 1px solid #ccc;
                border-bottom: none;
            }

            .homepage-categories .category-image-text,
            .susainability-page-categories .category-image-text {
                background: #0c2c6d;
                padding: 20px 0;
                text-align: center;
            }

            .homepage-categories .category-image-text {
                height: 65px;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .homepage-categories .category-image-text h3,
            .susainability-page-categories .category-image-text h3 {
                color: #ffffff;
            }
            .susainability-page-categories .category-image-text h3 {
                font-size: 18px;
                line-height: 20px;
                margin: 0;
            }

            .homepage-additional-markets {
                padding: 80px 0;
            }

            .homepage-additional-markets p {
                margin: 0px;
                padding-bottom: 20px;
            }

            .homepage-additional-markets h3 {
                margin: 0px;
            }

            .homepage-additional-markets .left a {
                color: #0c2c6d;
                font-weight: 800;
            }

            .homepage-additional-markets .right a {
                color: #e51d25;
                font-weight: 800;
            }

            .homepage-additional-markets h2 {
                font-size: 40px;
                text-align: center;
                padding-bottom: 20px;
                font-weight: 300;
            }

            .homepage-additional-markets h3 {
                font-size: 30px;
                font-weight: 300;
                padding: 20px 0;
            }

            .homepage-additional-markets .right h3 {
                color: #e51d25;
            }

            .homepage-additional-markets .grid {
                gap: 15px;
            }

            .homepage-about-us {
                background: #0c2c6d;
                position: relative;
                padding: 50px 20px;
            }

            .homepage-about-us .left-img {
                flex: 0 1 auto;
                width: 50%;
            }
            .homepage-about-us .right-content {
                width: 50%;
            }
            .homepage-about-us .grid {
                align-items: center;
                gap: 100px;
                position: relative;
                z-index: 1;
            }
            @media all and (max-width: 768px) {
                .homepage-about-us .left-img {
                    width: 100%;
                }
                .homepage-about-us .right-content {
                    width: 100%;
                }
                .homepage-about-us .grid {
                    gap: 00px;
                }
            }
            .homepage-about-us .left-circle {
                position: absolute;
                left: 0;
                top: 0;
            }

            .homepage-about-us .right-circle {
                position: absolute;
                right: 0;
                bottom: 0;
            }

            .homepage-about-us .left-circle img,
            .homepage-about-us .right-circle img {
                width: 100px;
            }

            .homepage-about-us h2,
            .homepage-about-us p {
                color: #ffffff;
            }
            .homepage-about-us h2 {
                line-height: 1.25em;
            }

            .narrow-wrapper {
                max-width: 650px;
                margin: 0 auto;
                text-align: center;
            }

            @media (max-width: 767px) {
                .grid {
                    flex-wrap: wrap;
                }
                .category-image-wrapper {
                    flex: 1 1 40%;
                }
                .homepage-blog-posts .grid div {
                    flex: 0 1 48%;
                }

                .homepage-categories .category-image-wrapper {
                    flex: 0 1 48%;
                }
            }

            @media (max-width: 1199px) {
                .wrapper {
                    padding: 0 15px;
                }
            }

            @media (max-width: 490px) {
                .utility-links {
                    font-size: 12px;
                }
                .homepage-categories .category-image-wrapper {
                    flex: 0 1 100%;
                }

                .homepage-sustainable-solutions .grid .col {
                    flex: 0 1 100%;
                }

                .homepage-sustainable-solutions .grid .col img {
                    width: 50%;
                }

                .homepage-sustainable-solutions .grid .col.col-img {
                    text-align: center;
                }

                .homepage-about-us .grid {
                    padding: 100px 0;
                    gap: 10px;
                }

                .homepage-get-started .grid .right {
                    padding: 20px;
                }

                .homepage-blog-posts .grid div {
                    flex: 0 1 100%;
                }
            }
        `,
    },
    textField: {
        defaultProps: {
            labelProps: {
                forwardAs: "label",
                size: "14px",
            },
        },
    },
});
